import '@/shared/configs/i18n.config';
import './app/styles/index.css';

import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

import { App } from '@/app';
import { ErrorBoundary } from '@/app/providers/error-boundary';
import { StoreProvider } from '@/app/providers/store';

const legacyGrafanaPrefix = '/yachting/grafana';

if (
	window.location.pathname === legacyGrafanaPrefix ||
	window.location.pathname.startsWith(`${legacyGrafanaPrefix}/`)
) {
	window.location.replace(
		`${window.location.origin}/grafana${window.location.pathname.slice(legacyGrafanaPrefix.length)}${
			window.location.search
		}${window.location.hash}`,
	);
}

Sentry.init({
	dsn: 'https://b42d606a17a9368b4bef2cb41a01b0c9@o4510487588306944.ingest.de.sentry.io/4510512767369296',
	environment: SENTRY_ENV,
	// environment: 'dev',
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	sendDefaultPii: true,
	integrations: [
		Sentry.reactRouterV6BrowserTracingIntegration({
			useEffect: useEffect,
			useLocation,
			useNavigationType,
			createRoutesFromChildren,
			matchRoutes,
		}),
	],
	tracesSampleRate: 1.0,
});

const rootElement = document.getElementById('root');

if (rootElement) {
	const root = createRoot(rootElement);

	root.render(
		<BrowserRouter>
			<StoreProvider>
				<HelmetProvider>
					<ErrorBoundary>
						<App />
					</ErrorBoundary>
				</HelmetProvider>
			</StoreProvider>
		</BrowserRouter>,
	);
} else {
	throw new Error('Root container missing in index.html');
}
